import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function EvChargingStationIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 14V20H3V6C3 4.89543 3.89543 4 5 4H11C12.1046 4 13 4.89543 13 6V14ZM13 14H16C17.1046 14 18 14.8954 18 16V16.5C18 17.3284 18.6716 18 19.5 18C20.3284 18 21 17.3284 21 16.5V8.82843C21 8.29799 20.7893 7.78929 20.4142 7.41421L17 4M8 9L6 12H10L8 15M21 9.5C21 10.3284 20.3284 11 19.5 11C18.6716 11 18 10.3284 18 9.5C18 8.67157 18.6716 8 19.5 8C20.3284 8 21 8.67157 21 9.5Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
